import PropTypes from 'prop-types';
import React from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';

const ScenarioFilter = ({ onUpdateFilter }) => (
  <div className='scenario-filter'>
    <FormGroup>
      <FormControl
        type='text'
        placeholder='SEARCH SCENARIOS'
        onChange={onUpdateFilter}
      />
    </FormGroup>
  </div>
);

ScenarioFilter.propTypes = {
  onUpdateFilter: PropTypes.func,
};

export default ScenarioFilter;
